import { render, staticRenderFns } from "./numberstep1.vue?vue&type=template&id=5e6b2f6f&scoped=true&"
import script from "./numberstep1.vue?vue&type=script&lang=js&"
export * from "./numberstep1.vue?vue&type=script&lang=js&"
import style0 from "./numberstep1.vue?vue&type=style&index=0&id=5e6b2f6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b2f6f",
  null
  
)

export default component.exports